module.exports = __webpack_public_path__ + "diversity.60eb2164.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/diversity.svg
// module id = 1734
// module chunks = 0